import { render, staticRenderFns } from "./SubscriptionsTable.vue?vue&type=template&id=fa3e524a"
import script from "./SubscriptionsTable.vue?vue&type=script&lang=js"
export * from "./SubscriptionsTable.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionsTable.vue?vue&type=style&index=0&id=fa3e524a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports